/* This file is autogenerated, see readme.md for instructions */
import HomeSvgIcon from '@bloomreach/banana-theme/icons/home.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const HomeIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <HomeSvgIcon />
    </Icon>
  );
});

HomeIcon.displayName = 'HomeIcon';

export default HomeIcon;
